import { pick } from 'lodash';

export const obfuscateConfig = (config: Record<string, unknown>) => {
    return pick(config, 'from', 'to', 'attributes', 'segment_by', 'interval');
};
